/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Restaurant',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path d="M11.808 4.464c.339 0 .615.276.615.615v3.56c0 .681-.306 1.326-.833 1.758l-.604.493c-.218.178-.514.387-.514.669l.208 7.051a.83.83 0 0 1-.832.858.83.83 0 0 1-.831-.863l.255-7.084c0-.264-.261-.463-.466-.631l-.603-.494a2.27 2.27 0 0 1-.831-1.756V5.079c0-.34.276-.615.615-.615s.615.276.615.615V8.64a1.04 1.04 0 0 0 .114.474c.046.089.143.136.243.136.172 0 .312-.14.312-.312V5.163a.6.6 0 1 1 1.2 0v3.742c0 .19.154.344.344.344.11 0 .217-.051.267-.149.071-.141.109-.299.109-.461v-3.56c0-.339.276-.615.615-.615zm3.265.637c.239-.384.742-.206.742.246l.027 13.211c.005.484-.387.879-.871.88a.87.87 0 0 1-.867-.956l.534-5.474c.019-.193-.1-.373-.284-.434l-.381-.124a.83.83 0 0 1-.571-.787v-.501c0-2.853.962-4.923 1.671-6.062z" />
          <path
            fillRule="evenodd"
            d="M12.565 1.017A11 11 0 0 1 22.998 12l-.015.565A11 11 0 0 1 12 22.998l-.566-.015A11 11 0 0 1 1.017 12.565L1.002 12A11 11 0 0 1 12 1.002l.565.015zM12 2.202A9.8 9.8 0 0 0 2.202 12 9.8 9.8 0 0 0 12 21.798 9.8 9.8 0 0 0 21.798 12 9.8 9.8 0 0 0 12 2.202z"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
